<template>
  <div>
    <div class="authorizationCodeManage div-layout">
      <div class="authorizationCodeManage-main">
        <module-title title="授权码管理">
          <div class="right">
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-download"
              @click="openExport('export')"
            >
              导出
            </el-button>
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-plus"
              @click="openBulkGeneration"
            >
              批量生成
            </el-button>
          </div>
        </module-title>
        <div class="authorizationCodeManage-main-contain">
          <el-form
            ref="searchForm"
            :model="searchForm"
            :inline="true"
            label-position="right"
            label-width="100px"
          >
            <el-form-item label="授权码：" prop="authorizationCode">
              <el-input
                v-model="searchForm.authorizationCode"
                name="authorizationCode"
                placeholder="请输入授权码"
                class="handle-form-input"
              />
            </el-form-item>
            <el-form-item label="设备类型：" prop="deviceType">
              <el-select
                v-model="searchForm.deviceType"
                name="deviceType"
                size="medium"
                class="handle-form-input"
              >
                <el-option label="全部" value />
                <el-option
                  v-for="item in terminalList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="状态：" prop="status">
              <el-select
                v-model="searchForm.status"
                name="status"
                size="medium"
                class="handle-form-input"
              >
                <el-option label="全部" value />
                <el-option label="启用" :value="1" />
                <el-option label="禁用" :value="0" />
              </el-select>
            </el-form-item>
            <el-form-item style=" margin-left:50px;">
              <el-button
                type="primary"
                size="medium"
                icon="el-icon-search"
                @click="handleSearchFilter"
              >
                查询
              </el-button>
            </el-form-item>
          </el-form>
          <multiple-box :visible="isSelection" :selection-num="selectionNum">
            <span v-show="hasUnUsing" class="handle-span" @click="multipleEditStatus(1)">批量启用</span>
            <span v-show="hasUsing" class="handle-span" @click="multipleEditStatus(0)">批量禁用</span>
          </multiple-box>
          <el-table
            v-loading="listLoading"
            :data="authorizationCodeList"
            highlight-current-row
            fit
            element-loading-text="Loading"
            class="list-table"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column type="index" width="55" align="center" label="序号" />
            <el-table-column label="授权码" prop="authorizationCode" align="center" />
            <el-table-column label="设备类型" prop="deviceTypeName" align="center" />
            <el-table-column label="授权机构" prop="orgName" align="center" />
            <el-table-column label="授权状态" prop="authorizationType" align="center" width="100">
              <template slot-scope="scope">
                {{ scope.row.authorizationType===1?'已授权':'未授权' }}
              </template>
            </el-table-column>
            <el-table-column label="状态" prop="status" align="center" width="100">
              <template slot-scope="scope">
                {{ scope.row.status?'启用':'禁用' }}
              </template>
            </el-table-column>
            <el-table-column label="授权时间" prop="authorizationTime" align="center" width="150">
              <template slot-scope="scope">
                {{ scope.row.createDate }}
              </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="createDate" align="center" width="150">
              <template slot-scope="scope">
                {{ scope.row.createDate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200px">
              <template slot-scope="scope">
                <el-button
                  type="success"
                  size="small"
                  icon="el-icon-info"
                  @click="viewCodeDetail(scope.row)"
                >
                  查看
                </el-button>
                <el-button
                  v-if="!scope.row.status"
                  type="success"
                  size="small"
                  icon="el-icon-success"
                  @click="handleUseEdit(scope.row)"
                >
                  启用
                </el-button>
                <el-button
                  v-if="scope.row.status"
                  type="warning"
                  size="small"
                  icon="el-icon-warning-outline"
                  @click="handleUseEdit(scope.row)"
                >
                  禁用
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="searchForm.total"
            :page.sync="searchForm.pageNum"
            :limit.sync="searchForm.pageSize"
            @pagination="pageCurriculumList"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>

      <!-- 批量生成授权码 -->
      <el-dialog
        v-if="hiddenVariable.dialogEditVisible"
        :close-on-click-modal="false"
        :visible.sync="hiddenVariable.dialogEditVisible"
        title="批量生成授权码"
        width="600px"
      >
        <el-form
          ref="handleForm"
          :model="handleForm"
          :rules="handleRules"
          label-position="right"
          label-width="150px"
        >
          <el-form-item label="设备类型：" prop="deviceType">
            <el-select
              v-model="handleForm.deviceType"
              name="deviceType"
              size="medium"
              class="handle-form-input"
            >
              <el-option
                v-for="item in terminalList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="授权机构：" prop="orgCodes">
            <el-button type="primary" size="medium" @click="openExport('select')">
              选择机构
            </el-button>
            <el-input v-model="handleForm.orgCodes" style="display: none;" />
            <span v-show="selectOrgText" class="orgCodesText">{{ selectOrgText }}</span>
          </el-form-item>
          <el-form-item label="生成数量：" prop="batchAddSize">
            <el-input-number
              v-model="handleForm.batchAddSize"
              :min="1"
              :max="1000"
              name="batchAddSize"
              auto-complete="off"
              size="medium"
              placeholder="请输入"
              class="handle-form-input"
              clearable
            />
          </el-form-item>
          <el-form-item prop="failureDateStr" label="失效时间：">
            <el-date-picker
              v-model="handleForm.failureDateStr"
              :picker-options="pickerOptions"
              type="date"
              size="medium"
              class="handle-form-input"
              value-format="yyyy-MM-dd"
              clearable
              placeholder="选择失效时间"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="hiddenVariable.dialogEditVisible = false">
            取消
          </el-button>
          <el-button
            :loading="ajaxLoading"
            type="primary"
            size="medium"
            @click="handleBatch"
          >
            {{ ajaxLoading?'Loading':'确定' }}
          </el-button>
        </div>
      </el-dialog>

      <!-- 选择机构 -->
      <el-dialog
        :close-on-click-modal="false"
        :visible.sync="hiddenVariable.dialogOrgVisible"
        title="选择机构"
        width="500px"
      >
        <el-tree
          ref="orgTree"
          :data="orgTreeData"
          node-key="code"
          :props="defaultProps"
          class="orgTree"
          highlight-current
        />
        <div slot="footer" class="dialog-footer">
          <!-- <el-button size="medium" @click="hiddenVariable.dialogOrgVisible = false">取消</el-button> -->
          <el-button type="primary" size="medium" @click="handleSelectOrg">
            确定
          </el-button>
        </div>
      </el-dialog>

      <!-- 授权码详情 -->
      <el-dialog
        v-if="hiddenVariable.dialogDetailVisible"
        :close-on-click-modal="false"
        :visible.sync="hiddenVariable.dialogDetailVisible"
        title="授权码详情"
        width="650px"
      >
        <div class="manager-info">
          <ul style="width: 100%;">
            <li>
              <label for>授权码：</label>
              {{ authorizationCodeDetail.authorizationCode }}
            </li>
          </ul>
        </div>
        <div class="manager-info">
          <ul>
            <li>
              <label for>授权机构：</label>
              {{ authorizationCodeDetail.orgName }}
            </li>
            <li>
              <label for>禁用状态：</label>
              {{ authorizationCodeDetail.status?'启用':'禁用' }}
            </li>
            <li>
              <label for>失效时间：</label>
              {{ authorizationCodeDetail.failureTime }}
            </li>
          </ul>
          <ul>
            <li>
              <label for>授权状态：</label>
              {{ authorizationCodeDetail.authorizationType===1?'已授权':'未授权' }}
            </li>
            <li>
              <label for>生成时间：</label>
              {{ authorizationCodeDetail.createDate }}
            </li>
          </ul>
        </div>
        <el-divider />
        <p class="archivesTitle">
          授权设备信息
        </p>
        <div class="manager-info">
          <ul>
            <li>
              <label for>设备类型：</label>
              {{ authorizationCodeDetail.deviceTypeName }}
            </li>
            <li>
              <label for>授权时间：</label>
              {{ authorizationCodeDetail.authorizationTime }}
            </li>
          </ul>
          <ul>
            <li>
              <label for>设备识别码：</label>
              {{ authorizationCodeDetail.deviceCode }}
            </li>
          </ul>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import { formatTimeToStr } from '@/utils/index';
import {
  getAuthorizationCodeList,
  updateAuthorizationCodeStatus,
  getAuthorizationCodeDetail,
  getOrgTree,
  exportAuthorizationCode,
  batchAuthorizationCode
} from '@/api/systemMaintenance/devicManage/authorizationCode';
import { getDictsType } from '@/api/productOperation/common/applicationManage';
export default {
  name: 'AuthorizationCodeManage',
  data() {
    return {
      handleType: 'export',
      ajaxLoading: false,
      // 所有控制显示隐藏变量
      hiddenVariable: {
        dialogEditVisible: false,
        dialogDetailVisible: false,
        dialogOrgVisible: false
      },
      // 搜索表单
      searchForm: {
        deviceType: '', // 设备类型Id
        authorizationCode: '',
        status: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      handleForm: {
        batchAddSize: 0,
        orgCodes: '',
        deviceType: '',
        failureDateStr: ''
      },
      listLoading: false, // 表格刷新loading
      multipleSelection: [], // 表格多选,
      authorizationCodeList: [],
      terminalList: [], //  终端列表
      authorizationCodeDetail: {},
      defaultProps: {
        children: 'childOrgList',
        label: 'name'
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now(); // 如果没有后面的-8.64e7就是不可以选择今天
        }
      }, // 时间控件限制
      orgTreeData: [],
      selectOrgCode: '',
      selectOrgText: '',
      // 上传应用信
      handleRules: {
        batchAddSize: [
          { required: true, message: '生成数量不能为空', trigger: 'blur' }
        ],
        orgCodes: [
          { required: true, message: '授权机构不能为空', trigger: 'change' }
        ],
        deviceType: [
          { required: true, message: '设备类型不能为空', trigger: 'blur' }
        ],
        failureDateStr: [
          { required: true, message: '失效日期不能为空', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    formatTimeToStr() {
      return formatTimeToStr;
    },
    // 是否多选
    isSelection() {
      return this.multipleSelection.length > 0;
    },
    // 多选数量
    selectionNum() {
      return this.multipleSelection.length;
    },
    // 是否是启用的
    hasUsing() {
      return this.multipleSelection.findIndex(item => item.status) > -1;
    },
    // 是否是禁用的
    hasUnUsing() {
      return this.multipleSelection.findIndex(item => !item.status) > -1;
    }
  },
  mounted() {
    this.fetchAuthorizationCodeList();
    this.fetchTerminalList();
    this.fetchOrgTree();
  },
  methods: {
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchAuthorizationCodeList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchAuthorizationCodeList();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchAuthorizationCodeList();
    },
    // 表格选择事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // 查看授权码详情
    viewCodeDetail(row) {
      getAuthorizationCodeDetail(row.id)
        .then(res => {
          this.authorizationCodeDetail = res.data;
          this.hiddenVariable.dialogDetailVisible = true;
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 打开批量生成弹框
    openBulkGeneration() {
      this.handleForm = {
        batchAddSize: 0,
        orgCodes: '',
        deviceType: '',
        failureDateStr: ''
      };
      this.hiddenVariable.dialogEditVisible = true;

      if (this.$refs.orgTree) {
        this.selectOrgCode = '';
        this.selectOrgText = '';
        this.$refs.orgTree.setCurrentKey(null);
      }
    },
    // 打开批量生成弹框
    openExport(type) {
      this.handleType = type;
      this.hiddenVariable.dialogOrgVisible = true;
      if (this.$refs.orgTree) {
        if (this.selectOrgCode && type === 'select') {
          this.$refs.orgTree.setCurrentKey(this.selectOrgCode);
        } else {
          this.$refs.orgTree.setCurrentKey(null);
        }
      }
    },

    // 确定选择机构
    handleSelectOrg() {
      const selectOrgCode = this.$refs.orgTree.getCurrentKey();
      this.selectOrgCode = selectOrgCode || '';
      this.selectOrgText = this.$refs.orgTree.getCurrentNode().name;
      const orgCodes = (selectOrgCode && selectOrgCode) || '';
      // const orgCodes = selectOrgCode.map(x => x.code).join(',')
      if (this.handleType === 'export' && orgCodes) {
        // exportAuthorizationCode(orgCodes)
        //   .then(result => {
        //     console.log(result);
        //     // 将lob对象转换为域名结合式的url
        //     const blobUrl = window.URL.createObjectURL(result);
        //     const link = document.createElement('a');
        //     document.body.appendChild(link);
        //     link.style.display = 'none';
        //     link.href = blobUrl;
        //     // 设置a标签的下载属性，设置文件名及格式，后缀名最好让后端在数据格式中返回
        //     link.download = '';
        //     // 自触发click事件
        //     link.click();
        //     document.body.removeChild(link);
        //     window.URL.revokeObjectURL(blobUrl); // 释放URL
        //   })
        //   .catch(err => {
        //     console.log(err);
        //     this.uploadLoading = false;
        //     this.$message.warning('数据错误，无法下载');
        //   });
        window.location.href = exportAuthorizationCode(orgCodes);
      } else {
        this.handleForm.orgCodes = orgCodes;
        this.hiddenVariable.dialogOrgVisible = false;
      }
    },

    // 批量生成二维码
    handleBatch() {
      this.$refs['handleForm'].validate(valid => {
        if (valid) {
          batchAuthorizationCode(this.handleForm)
            .then(res => {
              this.hiddenVariable.dialogEditVisible = false;
              this.fetchAuthorizationCodeList();
              this.$confirm('已批量生成授权码，点击确定按钮可以下载表格?', '生成成功', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'success'
              }).then(() => {
                const selectOrgCode = this.$refs.orgTree.getCurrentKey();
                const orgCodes = selectOrgCode.code;
                window.location.href = exportAuthorizationCode(orgCodes);
              });
            }).catch(err => {
              console.log(err);
              this.$message.warning('请求错误');
            });
        }
      });
    },

    // 启用禁用
    handleUseEdit(row) {
      this.$confirm(
        `确定要${row.status ? '禁用' : '启用'}该授权码么?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          const form = {
            ids: row.id,
            status: row.status ? 0 : 1
          };
          return updateAuthorizationCodeStatus(form);
        })
        .then(res => {
          this.$notify.success({
            title: 'Success',
            message: `${row.status ? '禁用' : '启用'}成功`,
            showClose: false,
            duration: 2000
          });
          this.fetchAuthorizationCodeList();
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 批量启用或者禁用
    multipleEditStatus(type) {
      let str = '';
      let status = 1;
      let ids = [];
      let num = 0;
      // 启用
      if (type) {
        str = '启用';
        status = 1;
        // 筛选出是禁用状态的数据
        const idArr = this.multipleSelection.filter(item => !item.status);
        // 如果全部为启用状态则给出提示
        if (idArr.length === 0) {
          this.$message.warning('授权码全部为已启用状态');
          return false;
        } else {
          // 数组转字符串
          ids = idArr.map(item => item.id);
          num = idArr.length;
        }
        // 禁用
      } else {
        str = '禁用';
        status = 0;
        // 筛选出是启用状态的数据
        const idArr = this.multipleSelection.filter(item => item.status);
        // 如果全部为禁用状态则给出提示
        if (idArr.length === 0) {
          this.$message.warning('授权码全部为已禁用状态');
          return false;
        } else {
          // 数组转字符串
          ids = idArr.map(item => item.id);
          num = idArr.length;
        }
      }
      this.$confirm(`当前已选择${num}个授权码，确定要批量${str}么?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const form = {
            ids: ids.join(','),
            status: status
          };
          return updateAuthorizationCodeStatus(form);
        })
        .then(res => {
          this.$notify.success({
            title: 'Success',
            message: `${str}成功`,
            showClose: false,
            duration: 2000
          });
          this.fetchAuthorizationCodeList();
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 获取应用列表
    fetchAuthorizationCodeList() {
      this.listLoading = true;
      getAuthorizationCodeList(this.searchForm)
        .then(result => {
          if (result.data && result.data.list && result.data.list.length) {
            this.authorizationCodeList = result.data.list;
            this.searchForm.total = result.data.total;
          } else {
            this.authorizationCodeList = [];
            this.searchForm.total = 0;
          }
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.listLoading = false;
          this.authorizationCodeList = [];
          this.searchForm.total = 0;
        });
    },

    // 获取终端字典
    fetchTerminalList() {
      getDictsType('device_type')
        .then(result => {
          result.data = result.data.filter(x => x.name !== 'Android').filter(x => x.name !== 'ios');
          this.terminalList = result.data;
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 获取机构树
    fetchOrgTree() {
      getOrgTree()
        .then(result => {
          this.orgTreeData = result.data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.authorizationCodeManage {
  padding-bottom: 20px;
  .handle-form-input {
    width: 80%;
  }
  .manager-info {
    display: flex;
    ul {
      margin-left: 60px;
      width: 50%;
      min-width: 220px;
      li {
        margin-bottom: 20px;
      }
    }
  }
  .archivesTitle {
    color: #1890ff;
    font-size: 14px;
    font-weight: bold;
    padding-left: 30px;
    padding-bottom: 20px;
  }
  .orgTree {
    margin-left: 20px;
  }
  .orgCodesText{
    display: inline-block;
    font-size: 12px;
    border-radius: 4px;
    box-sizing: border-box;
    white-space: nowrap;
    margin-left: 20px;
    color: #909399;
    margin: 2px 0 2px 6px;
    height: 24px;
    padding: 0 8px;
    line-height: 22px;
  }
}
</style>

